import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class SheetEventService {
  static async update(id, data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SHEETEVENT_UPDATE(
          $id: String!
          $data: SheetEventInput!
        ) {
          sheetEventUpdate(id: $id, data: $data) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
      },
    });

    return response.data.sheetEventUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SHEETEVENT_DESTROY($ids: [String!]!) {
          sheetEventDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.sheetEventDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SHEETEVENT_CREATE($data: SheetEventInput!) {
          sheetEventCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.sheetEventCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation SHEETEVENT_IMPORT(
          $data: SheetEventInput!
          $importHash: String!
        ) {
          sheetEventImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.sheetEventImport;
  }

  static async find(id) {
    const response = await graphqlClient.query({
      query: gql`
        query SHEETEVENT_FIND($id: String!) {
          sheetEventFind(id: $id) {
            id
            type
            subtypeGame
            subtypeGoal
            subtypeCard
            subtypePenaltyShootout
            teamId {
              id
            }
            minute
            player {
              id
            }
            otherTeamId {
              id
            }
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
      },
    });

    return response.data.sheetEventFind;
  }

  static async list(filter, orderBy, limit, offset) {
    const response = await graphqlClient.query({
      query: gql`
        query SHEETEVENT_LIST(
          $filter: SheetEventFilterInput
          $orderBy: SheetEventOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          sheetEventList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              type
              subtypeGame
              subtypeGoal
              subtypeCard
              subtypePenaltyShootout
              teamId {
                id
              }
              minute
              player {
                id
              }
              otherTeamId {
                id
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.sheetEventList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query SHEETEVENT_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          sheetEventAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.sheetEventAutocomplete;
  }
}
